module.exports = __webpack_public_path__ + "img/tu1-2.9529696f.png";